import {messages} from '@smartmixin/i18n';
import {EnvelopeSimple} from '@phosphor-icons/react';
import {Box, Button, Typography} from '@mui/material';
import {useIntl} from 'react-intl';
import AppPaper from '../../components/AppPaper';
import {SUPPORT_EMAIL} from '../constants';

type HelpEscalationProps = {
  articleTitle?: string;
};

// Last stop on every article: self-serve failed, make contact easy.
const HelpEscalation = ({articleTitle}: HelpEscalationProps) => {
  const {formatMessage} = useIntl();

  const subject = articleTitle
    ? `SmartMixin Help — ${articleTitle}`
    : 'SmartMixin Help';
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;

  return (
    <AppPaper sx={{p: 3, mt: 3, textAlign: 'center'}}>
      <Typography variant="body1" sx={{fontWeight: 600, mb: 0.5}}>
        {formatMessage(messages.common.stillNeedHelp)}
      </Typography>
      <Typography variant="body2" sx={{color: 'text.secondary', mb: 2}}>
        {formatMessage(messages.common.stillNeedHelpDescription)}
      </Typography>
      <Box>
        <Button variant="outlined" startIcon={<EnvelopeSimple />} href={mailto}>
          {formatMessage(messages.common.contactMe)}
        </Button>
      </Box>
    </AppPaper>
  );
};

export default HelpEscalation;
